module.exports = __webpack_public_path__ + "img/return-ico.a1db76ff.svg";